module.exports = __webpack_public_path__ + "static/media/GirlSecondary.0201c37f.svg";